module.exports = __webpack_public_path__ + "static/media/welsh_flag.54ba1541.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/welsh_flag.png
// module id = 160
// module chunks = 0